// extracted by mini-css-extract-plugin
export default {"notFoundPage":"notfoundpage_notFoundPage__DqAk+","h1":"notfoundpage_h1__30fnR","h2":"notfoundpage_h2__cdI3E","p":"notfoundpage_p__Hyyyt","countdown":"notfoundpage_countdown__YnQgL"};